import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { List, PlusCircle, Trash } from "react-bootstrap-icons";
import { Button, Col, Table } from "react-bootstrap";
import Loader from 'react-loader-spinner';
import { setProductBugPop, setDialog } from "../../store/api/GetAllProduct";
import { addNewRepairBug, getRepairBugList, deleteRepairBug } from '../../store/api/Services';
import { setErrorDialog } from "../../../store/api/CommonFunctions";
const RepairBugs = (props) => {
    const dispatch = useDispatch();
    const [selectedProductBug, setBugData] = useState({});
    const { serviceID, productID, productTypeID, repairBugList } = props;
    const saveBug = () => {
        let bugId = document.getElementById("BugID").value;
        if (bugId === "") {
            return;
        }
        const onGet = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت ایراد فنی");
            }
            else if (res === "Success") {
                setBugData({});
                dispatch(getRepairBugList(serviceID));

            }
        }
        addNewRepairBug(serviceID, bugId, onGet);
    }
    return (
        <Fragment>
            <div className="row">
                <Col md={6} className="form-group" style={{ paddingLeft: 0 }}>
                    <label>ایراد فنی:</label>
                    <input type="hidden" id="BugID" readOnly value={selectedProductBug?.ID ?? ""} />
                    <input type="text" placeholder='ایراد را انتخاب کنید' className="form-control"
                        readOnly value={selectedProductBug?.Bug ? (selectedProductBug?.Code + '- ' + selectedProductBug.Bug) : ""} />
                    <Button className="btn-input-tiny" style={{ top: "26px", left: "3px" }} onClick={() => { dispatch(setProductBugPop({ status: 'show', productID: productID, productTypeID: productTypeID, setData: setBugData })) }}><List size="23px" /></Button>
                </Col>
                <Col md={3} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px", marginRight: 0, paddingRight: 0 }}>
                    <Button variant="info" className="group-Btn-smalll" onClick={saveBug}><PlusCircle size="23px" /></Button>
                </Col>
            </div>

            <Table className="mt-2">
                <thead>
                    <tr>
                        <th style={{ display: "none" }}></th>
                        <th>کد ایراد</th>
                        <th>شرح ایراد</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {repairBugList === 'PENDING' && <tr><td style={{ textAlign: "center" }} colSpan={9}><Loader type="BallTriangle" color="#bb1370" height={35} width={35} /></td></tr>}
                    {repairBugList && Array.isArray(repairBugList) &&
                        repairBugList.map((item, i) => <tr className="resultTableRow" key={i}>
                            <td style={{ display: "none" }}></td>
                            <td style={{ width: "70px" }}>{item.BugCode}</td>
                            <td>{item.BugDesc}</td>
                            <td style={{ width: "5px" }}><button className="btn rowBtn" style={{ padding: 0 }} type="button" onClick={() => {
                                dispatch(setDialog({
                                    status: 'show',
                                    arrayBtn: ['yes', 'no'],
                                    dialogTitle: 'حذف ایراد',
                                    dialogText: 'آیا از حذف مطمئن هستید؟',
                                    okOperation: deleteRepairBug(item.ID, () => { dispatch(getRepairBugList(serviceID)) })
                                }))
                            }} ><Trash className="rowBtn" color="red" size={18} /></button></td>
                        </tr>)
                    }
                </tbody>
            </Table>

        </Fragment>
    )
}
export default RepairBugs;